import React from "react";
import useDeviceType from "Utils/useDeviceType";
import ExerciseDetailPC from "./components/ExerciseDetailPC";
import ExerciseDetailMobile from "./components/ExerciseDetailMobile";
import { useParams } from "react-router-dom";
import useRequest from "../../../Utils/useRequest";
import { getPaper, getPaperStatus } from "../../../API/exercise";

export default function ExerciseDetail() {
    const { isPC } = useDeviceType();
    const { exerciseId } = useParams<{ exerciseId: string }>();
    const [data, { loading }, refreshData] = useRequest(
        () => getPaper(exerciseId, "1"),
        {},
        [exerciseId]
    ); //获取试卷
    const [headerData, { loading: headerLoading }, reloadHeadData] = useRequest(
        () => getPaperStatus(exerciseId),
        {},
        [exerciseId]
    ); //获取单个练习

    return (
        <div>
            {isPC && data && headerData && (
                <ExerciseDetailPC data={data} headerData={headerData} />
            )}

            {!isPC && data && headerData && (
                <ExerciseDetailMobile data={data} headerData={headerData} />
            )}
        </div>
    );
}
